import { ESiteBonusTransferStatus } from "@/types/backoffice/dto/bonus-offer/site-bonus-transfer-dto";

const installationFlowLocale = {
  installationFlow: {
    widgetTitle: "Statut de l'installation",
    flow: {
      fieldName: "Méthode",
      provision: "Mise à disposition",
      sale: "Vente",
    },
    status: {
      fieldName: "Statut",
      done: "Terminée",
      ongoing: "En cours",
      canceled: "Annulée",
      pending: "Une erreur a eu lieu pendant la demande de signature",
      error: "Erreur",
    },
    esc: {
      preInterventionEscQuote: "Devis pré-intervention",
      escPackage: "Dossier CEE",
      validate: "Valider le dossier CEE",
      validateSuccess: "Dossier CEE validé",
      waitingValidation: "En attente de validation",
      validated: "Validé",
      signed: "Signé",
      quoteUploadDate: "Devis uploadé le",
      sendCustomerServiceCertificate: "Envoyer attestation SAV",
    },
    is: {
      installationSheet: "Fiche installation",
      signed: "Signée",
      uploadDate: "Fiche uploadée le",
      notUploaded: "Fiche en attente d'upload",
      upgradeToEsc: "Basculer sur une vente",
    },
    signature: {
      sendReminder: "Envoyer un rappel de signature",
      sendReminderSuccess: "Demande de signature renvoyée",
      requestDate: "Signature demandée le",
      cancel: "Annuler la demande de signature",
      canceled: "Signature annulée",
      cancelSuccess: "Annulation réussie",
      regenerate: "Régénérer une nouvelle signature",
      regenerateSuccess: "Signature regénérée",
    },
    bonusTransfer: {
      title: "Prime",
      offer: "Offre : {label}",
      expirationDate: "Date expiration prime : {date}",
      IBANreceiptDate: "Date réception IBAN : {date}",
      resendMessage: "Renvoyer Email saisie IBAN",
      externalTransfer: {
        text: "Virement Swan : {id} ({status})",
        status: {
          [ESiteBonusTransferStatus.INITIALIZED]: "Initialisé",
          [ESiteBonusTransferStatus.SUBMISSION_ERROR]: "Erreur de soumission",
          [ESiteBonusTransferStatus.CONSENT_ERROR]: "Erreur de consentement",
          [ESiteBonusTransferStatus.PENDING]: "En attente",
          [ESiteBonusTransferStatus.SUBMITTED]: "Soumis",
          [ESiteBonusTransferStatus.REJECTED]: "Rejeté",
          [ESiteBonusTransferStatus.BOOKED]: "Réservé",
          [ESiteBonusTransferStatus.NONEXISTENT]: "Aucun",
        },
      },
    },
  },
};

export type InstallationFlowLocale = typeof installationFlowLocale;
export default installationFlowLocale;
